import { shelvDesignVariables } from "../../brandConfig";
import React from "react";
import { StandardLoginPage } from "../authentication/components/StandardLoginPage";
import logo from "./assets/wordmark.svg";
import "./shelv-design.css";
import { SHELV_UI_SCOPE } from "./ui";

export default function ShelvEntry() {
  return <main className={`shelv-entry ${SHELV_UI_SCOPE}`} style={shelvDesignVariables as React.CSSProperties}>
    <StandardLoginPage defaultReturnPath="/shelv" branding={{
      header: <img className="shelv-entry-logo" src={logo} alt="Shelv" width={109} height={32} />,
      title: "One email, one link", description: "You know the drill.", submitLabel: "Send Magic Link",
    }} />
  </main>;
}
